'use strict';

export class FaqFeedback {
	constructor(component_id) {
		this.id = component_id;
	}

	init() {
		const $root = jQuery('.js-' + this.id);

		jQuery(document).on('click', '.js-faq_feedback_icon', function() {
			const $btn = jQuery(this);
			const helpful = $btn.data('helpful');
			const $wrapper = $btn.closest('.faq_feedback, .js-faq_feedback');

			if (helpful === 'y') {
				const text = jQuery('.js-faq_feedback_helpful').text();
				$wrapper.addClass('faq_feedback--success').text(text);
			} else {
				const $link_source = jQuery('.js-faq_feedback_contact');
				if ($link_source.length) {
					$wrapper.addClass('faq_feedback--info').html($link_source.html());
					$wrapper.find('a').removeAttr('target').removeAttr('href').on('click', function() {
						jQuery('.js-faq_categories_faq_categories, .js-accordion_popular, .js-faq_search_top').slideUp();
						jQuery('.js-contact_form_wrapper').removeClass('hidden').show();
					});
				}
			}
		});
	}
}


const init_faq_feedback = () => {
	if (typeof yalwa === 'undefined' || !yalwa.v || !yalwa.v.components) return;
	for (const key in yalwa.v.components) {
		if (key.startsWith('faq_feedback_') || key.startsWith('fb_')) {
			new FaqFeedback(key).init();
		}
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init_faq_feedback);
} else {
	init_faq_feedback();
}